import { render, staticRenderFns } from "./AlertMessage.vue?vue&type=template&id=6504af1a&"
import script from "./AlertMessage.vue?vue&type=script&lang=js&"
export * from "./AlertMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports